import {Component, Inject, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {Router, NavigationExtras} from '@angular/router';
import {CardMealService} from '../card-mealService';
import {LoginService} from '../../../../../../shared-modules/login/login.service';
import {UserService} from '../../../../../../shared-components/user/user.service';
@Component({
  selector: 'app-meal-service-card-modal',
  templateUrl: './meal-service-card-modal.component.html',
  styleUrls: ['./meal-service-card-modal.component.css']
})
export class MealServiceCardModalComponent implements OnInit {
  mealLedger: CardMealService;
  rolloverBalance = 0;
  deposits = 0;
  balance = 0;
  absBalance = 0; // Absolute value
  charges = 0;
  userType: number;
  showPay = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
     private router: Router,
     private dialogRef: MatDialogRef<MealServiceCardModalComponent>,
     private userService: UserService,
     private loginService: LoginService
     ) { }

  ngOnInit() {
    this.mealLedger = this.data.mealLedger;
    this.balance = this.mealLedger.Balance;
    this.absBalance = Math.abs(this.mealLedger.Balance);
    this.rolloverBalance = this.mealLedger.Rollover_Balance;
    this.deposits = this.mealLedger.Deposits;
    this.charges = this.mealLedger.Charges;
    this.userType = this.userService.userType;
    this.showPay = this.data.showPay;
  }

  viewDetailsClick() {
    this.closeClick();
    this.router.navigateByUrl('/student360/mealService');
  }

  payClick() {
    this.closeClick();
    const navigationExtras: NavigationExtras = {
      // The view to Meal Accounts
      queryParams: {
          'selectedView': 2
      }
  };
  this.router.navigate(['/student360/onlinePayment'], navigationExtras);
  }

  closeClick() {
    this.dialogRef.close();
  }

  checkIfNegative(balance: number) {
    // If negative or zero return class
    if (balance <= 0) {
      return 'isNegative';
    }
  }
}
